/* All challenges page */

const MOUNTAIN_ASSET_DIMENSIONS = {
  width: 983,
  height: 819,
};

export const MOUNTAIN_ASPECT_RATIO = `${MOUNTAIN_ASSET_DIMENSIONS.width} / ${MOUNTAIN_ASSET_DIMENSIONS.height}`;

const HILLS_ASSET_DIMENSIONS = {
  width: 2232,
  height: 959,
};

export const HILLS_ASPECT_RATIO = `${HILLS_ASSET_DIMENSIONS.width} / ${HILLS_ASSET_DIMENSIONS.height}`;

// relative to the mountain size (%)
export const LAMP_RELATIVE_POSITIONS = [
  { top: 79.85348, left: 51.47508 },
  { top: 73.13797, left: 20.65107 },
  { top: 63.07797, left: 28.35107 },
  { top: 60.80586, left: 45.77823 },
  { top: 56.89866, left: 60.2238 },
  { top: 59.46276, left: 77.31434 },
  { top: 53.96825, left: 69.48118 },
  { top: 54.33455, left: 54.22177 },
  { top: 53.96825, left: 41.5056 },
  { top: 50.67155, left: 31.53611 },
  { top: 53.84615, left: 20.85453 },
  { top: 43.22344, left: 26.95829 },
  { top: 44.56654, left: 36.3174 },
  { top: 38.21734, left: 44.25229 },
  { top: 40.90354, left: 59.40997 },
  { top: 35.65324, left: 69.48118 },
  { top: 32.72283, left: 62.25839 },
  { top: 31.86813, left: 48.72838 },
  { top: 30.28083, left: 39.47101 },
  { top: 24.90842, left: 33.16378 },
  { top: 23.19902, left: 42.42116 },
  { top: 25.64103, left: 52.5941 },
  { top: 19.41392, left: 56.25636 },
  { top: 16.35922, left: 45.18515 },
];

// relative to the mountain size (%)
export const LAMP_RELATIVE_DIMENSIONS = {
  width: 2.15,
  height: 8.5,
};

export const PALETTE = {
  skyBackground: "#1c0a44",
  background: "#5035be",
  backgroundSecondary: "#4e2a9a",
  backgroundDark: "#181225",
  primary: "#7352FC",
  interactive: "#a08aff",
  headingSecondary: "#bcacff",
  highlight: "#3edcff",
  textPrimary: "#1b0746",
  textSecondary: "#61557b",
  textInverted: "#e8e8e8",
};

export const HEADER_HEIGHT = "96px";

export const SPACE = {
  xs: "4px",
  sm: "8px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "64px",
};

export const BREAKPOINTS = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const CHALLENGE_YEARS = [2024];
